import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { t } from 'ttag';
import useBasketContext from '../../contexts/basket/useBasketContext';
import useOrderContext from '../../contexts/order/useOrderContext';
import useSiteContext from '../../contexts/site/useSiteContext';
import { CTA } from '../general/Button';
import TinyModal from '../general/TinyModal';
import TimeslotSelectTwoPart from './TimeslotSelectTwoPart';
import { useStateRef } from "../../hooks/usestateref";
import { OrderData } from "../../contexts/order/order-context";
import { iLog } from "../../index";

type TimeslotModalProps = {
    onHide: () => void;
    show: boolean;
    type?: 'unavailable' | 'change';
};

const TimeslotModal = ({ onHide, show, type = 'unavailable' }: TimeslotModalProps) => {
    const siteContext = useSiteContext();
    const basketContext = useBasketContext();

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        document.getElementById('timeslot-modal')?.classList.add('anim-enter');

        return () => {
            document.getElementById('timeslot-modal')?.classList.remove('anim-enter');
        };
    }, [show]);

    useEffect(() => {
        if (
            (siteContext.site || basketContext.validatedSite)
            && !siteContext.timeslots?.length
            || show
        ) {
            iLog('timeslot useEffect - calling fetch timeslot', [siteContext.site, basketContext.validatedSite]);

            setLoading(true);

            siteContext.fetchTimeslots(
                siteContext.site?.uid ?? basketContext.validatedSite?.uid ?? '',
                siteContext.flow ?? 'noflow');

            setLoading(false);
        }
    }, [siteContext.site, show]);

    const handleTimeslotSave = async () => {
        setLoading(true);

        try {
            await basketContext.validateTimeslot();
        } catch (error) {
            console.error('Error revalidating the basket after timeslot issue.', error);
            setLoading(false);
        }

        setLoading(false);
        onHide();
    };

    const renderFooter = () => {
        return (
            <>
                <CTA block onClick={handleTimeslotSave} disabled={loading} loading={loading}>
                    <span>Done</span>
                </CTA>
            </>
        )
    }

    return (
        <TinyModal
            show={show}
            onHide={onHide}
            header="Select new time"
            footer={renderFooter()}
            modalID={'timeslot-modal'}
        >
           <>
               {type == 'unavailable' ? (
                   <Reason>{t`Sorry, the time slot you selected has been taken by another user. Please select a new time.`}</Reason>
               ) : (
                   <Reason>{t`Please select a time for your order.`}</Reason>
               )}
               <TimeslotSelectTwoPart
                   timeslots={siteContext.timeslots}
                   selectedTimeslotId={basketContext.timeslot?.id}
               />
           </>
        </TinyModal>
    );
};

const Reason = styled.p`
    margin-bottom: 12px !important;
`;

export default TimeslotModal;
